export default "__VITE_ASSET__Ci6ZE8DG__"